export default class UniqueKeyBuilder {
    static make = (uniqueKey: string, type: string) => {
        return [uniqueKey, type].join('-');
    };
}
